<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useQuery } from '@vue/apollo-composable'
import { GET_CURRENT_USER } from '../graphql/queries.ts'
import GetAppBar from './components/GetAppBar.vue'

const route = useRoute()
const router = useRouter()

const { result: userResult, error: userError } = useQuery(GET_CURRENT_USER)

if (userError.value) {
  router.push('/login') // redirect if not logged in
} 
const isRail = ref(false)


watch(
  () => route.params.patientId,
  (newVal) => {
    isRail.value = !!newVal
  },
  { immediate: true },
)

const isPatientActive = computed(() => {
  return !!route.params.patientId;
});


</script>

<template>
  <v-navigation-drawer
    permanent
    direction="vertical"
    class="bg-primary border-0 d-flex flex-column h-100"
    rail
    rail-width="68"
  >
    <!-- Logo -->
    <div class="text-center my-2 mr-1">
      <img
        src="/aunova2.svg"
        alt="Aunova Logo"
        width="60"
        height="60"
      />
    </div>

    <!-- Main nav items -->
    <v-list nav class="px-0">
      <v-list-item
        :to="{ name: 'patients-search', params: route.params }"
        exact
        active-class="mx-1"
        :class="{ 'mx-1 v-list-item--active': isPatientActive }"
        link
      >
        <div class="d-flex flex-column align-center">
          <v-icon class="mx-auto">mdi-account-search</v-icon>
          <v-list-item-title class="text-caption text-center"> Patients </v-list-item-title>
        </div>
      </v-list-item>
    </v-list>

   <!-- Spacer fills the remaining space -->
    <div class="flex-grow-1"></div>

    <!-- Account settings item at the bottom -->
    <v-list nav class="px-0 mb-4" style="position: absolute; bottom: -16px; ">
      <v-list-item
        :to="{ name: 'settings' }"
        exact
        active-class="mx-1"
        link
      >
        <div class="d-flex flex-column align-center">
          <v-icon class="mx-auto">mdi-cog</v-icon>
          <v-list-item-title class="text-caption text-center"> Account </v-list-item-title>
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <GetAppBar/>

  <router-view />
</template>


<style scoped>

</style>
